import { render, staticRenderFns } from "./ServiceStatusPage.vue?vue&type=template&id=10c3b5be&scoped=true&"
import script from "./ServiceStatusPage.vue?vue&type=script&lang=ts&"
export * from "./ServiceStatusPage.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceStatusPage.vue?vue&type=style&index=0&id=10c3b5be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3b5be",
  null
  
)

export default component.exports